module.exports = __webpack_public_path__ + "img/logo_spmv.22400391.png";